
import {
  normalizeSeed,
  isValidElectrumSeed,
  signPsbt,
  clearSecret,
    runLocalSigningSelfTest
} from "./wallet.js";

const tg = window.Telegram?.WebApp || null;

if (tg) {
  tg.ready();
  tg.expand();
}

const app = document.getElementById("app") || document.body;

let currentTransaction = null;
let secretSeed = null;




function getTransactionId() {

  console.log(
    "CURRENT URL:",
    window.location.href
  );


  console.log(
    "SEARCH:",
    window.location.search
  );


  const params =
    new URLSearchParams(
      window.location.search
    );


  const fromUrl =
    params.get("transactionId");


  console.log(
    "TRANSACTION ID:",
    fromUrl
  );


  if (fromUrl) {
    return fromUrl;
  }


  if (tg?.initDataUnsafe?.start_param) {

    console.log(
      "START PARAM:",
      tg.initDataUnsafe.start_param
    );

    return tg.initDataUnsafe.start_param;
  }


  return null;
}





/*
function getTransactionId() {
  const params = new URLSearchParams(window.location.search);

  // Локальный режим:
  // http://127.0.0.1:3001/?transactionId=1
  const fromUrl = params.get("transactionId");

  if (fromUrl) {
    return fromUrl;
  }

  // Позже Telegram будет передавать start_param.
  if (tg?.initDataUnsafe?.start_param) {
    return tg.initDataUnsafe.start_param;
  }

  return null;
}

function formatBtc(value) {
  const number = Number(value || 0);

  return number.toLocaleString("ru-RU", {
    minimumFractionDigits: 8,
    maximumFractionDigits: 8
  }) + " BTC";
}

function shortAddress(address) {
  if (!address) {
    return "—";
  }

  if (address.length <= 24) {
    return address;
  }

  return `${address.slice(0, 12)}…${address.slice(-12)}`;
}*/

function setStatus(text, type = "") {
  const element = document.getElementById("status");

  if (!element) {
    return;
  }

  element.textContent = text;
  element.className = `status ${type}`;
}

function renderLoading() {
  app.innerHTML = `
    <div class="wallet-card">
      <h1>🔐 Подпись транзакции</h1>
      <div class="status">Загрузка транзакции…</div>
    </div>
  `;
}

function renderError(message) {
  app.innerHTML = `
    <div class="wallet-card">
      <h1>❌ Ошибка</h1>

      <div class="status error">
        ${escapeHtml(message)}
      </div>

      <button id="reloadButton">
        Повторить
      </button>
    </div>
  `;

  document
    .getElementById("reloadButton")
    ?.addEventListener("click", loadTransaction);
}

function renderTransaction(transaction) {
  const serviceFee = Number(transaction.serviceFeeBtc || 0);
  const networkFee = Number(transaction.networkFeeBtc || 0);
  const recipientAmount = Number(
    transaction.recipientAmountBtc || 0
  );

  const total =
    recipientAmount +
    serviceFee +
    networkFee;

  app.innerHTML = `
    <div class="wallet-card">

      <h1>🔐 Подпись транзакции</h1>

      <div class="transaction">

        <div class="row">
          <span>Получатель</span>
          <strong title="${escapeHtml(transaction.recipient || "")}">
            ${escapeHtml(shortAddress(transaction.recipient))}
          </strong>
        </div>

        <div class="row">
          <span>Получит</span>
          <strong>
            ${formatBtc(recipientAmount)}
          </strong>
        </div>

        <div class="row">
          <span>Комиссия сервиса</span>
          <strong>
            ${formatBtc(serviceFee)}
          </strong>
        </div>

        <div class="row">
          <span>Комиссия сети</span>
          <strong>
            ${formatBtc(networkFee)}
          </strong>
        </div>

        <div class="row total">
          <span>Всего</span>
          <strong>
            ${formatBtc(total)}
          </strong>
        </div>

      </div>

      <div class="warning">
        ⚠️ Seed-фраза используется только локально
        для подписи транзакции и не отправляется
        на сервер.
      </div>

      <label for="seed">
        Electrum seed
      </label>

      <textarea
        id="seed"
        rows="4"
        autocomplete="off"
        autocapitalize="none"
        spellcheck="false"
        placeholder="Введите seed-фразу Electrum"
      ></textarea>

     <button id="signButton" type="button" >
  🔐 Подписать транзакцию
</button>

<button id="historyButton">
  📜 История кошелька
</button>

<div id="status" class="status"></div>

    </div>
  `;

document
    .getElementById("signButton")
    ?.addEventListener(
      "click",
      signTransaction
    );


  document
    .getElementById("historyButton")
    ?.addEventListener(
      "click",
      loadHistory
    );
}

async function loadTransaction() {
  const transactionId = getTransactionId();

  if (!transactionId) {
    renderError(
      "Не указан transactionId. Для локального теста откройте страницу с ?transactionId=ID"
    );

    return;
  }

  renderLoading();

  try {
    const response = await fetch(
      `/api/transaction/${encodeURIComponent(transactionId)}`
    );

    const data = await response.json();

    if (!response.ok || !data.ok) {
      throw new Error(
        data.error || "Не удалось получить транзакцию"
      );
    }

    currentTransaction = data.transaction;

    renderTransaction(currentTransaction);

  } catch (error) {
    console.error(error);

    renderError(
      error.message || "Ошибка загрузки транзакции"
    );
  }
}

async function signTransaction() {

setStatus("Нажатие получено");

  if (!currentTransaction) {
    setStatus(
      "❌ Транзакция не загружена",
      "error"
    );
    return;
  }

  const seedElement =
    document.getElementById("seed");

  const signButton =
    document.getElementById("signButton");

  if (!seedElement || !signButton) {
    setStatus(
      "❌ Не найдено поле seed или кнопка",
      "error"
    );
    return;
  }

  const seed =
    normalizeSeed(seedElement.value);

  if (!seed) {
    setStatus(
      "❌ Введите Electrum seed-фразу",
      "error"
    );
    return;
  }

  try {

    setStatus(
      "1/5 Проверяем seed..."
    );

    if (!isValidElectrumSeed(seed)) {
      throw new Error(
        "Неверная Electrum seed-фраза"
      );
    }

    secretSeed = seed;

    signButton.disabled = true;
    seedElement.disabled = true;

    setStatus(
      "2/5 Получаем ключи для входов..."
    );

    if (
      !Array.isArray(
        currentTransaction.inputPaths
      ) ||
      currentTransaction.inputPaths.length === 0
    ) {
      throw new Error(
        "У транзакции отсутствуют inputPaths"
      );
    }

    setStatus(
      "3/5 Подписываем транзакцию..."
    );

    const result = signPsbt(
      currentTransaction.psbt,
      secretSeed,
      currentTransaction.inputPaths
    );

    if (!result || !result.rawtx) {
      throw new Error(
        "signPsbt не вернул rawtx"
      );
    }

    setStatus(
      "4/5 Подпись создана. Очищаем seed..."
    );

    seedElement.value = "";
    secretSeed = clearSecret();

    setStatus(
      "5/5 Отправляем подписанную транзакцию..."
    );

    const response = await fetch(
      "/api/broadcast",
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json"
        },

        body: JSON.stringify({
          transactionId:
            currentTransaction.id,

          rawtx:
            result.rawtx
        })
      }
    );

    const data =
      await response.json();

    if (!response.ok || !data.ok) {
      throw new Error(
        data.error ||
        "Сервер не принял транзакцию"
      );
    }

    renderSuccess(data.txid);

  } catch (error) {

    console.error(
      "SIGN ERROR:",
      error
    );

    secretSeed =
      clearSecret();

    seedElement.value = "";

    seedElement.disabled = false;
    signButton.disabled = false;

    setStatus(
      "❌ " +
      (
        error.message ||
        "Ошибка подписи"
      ),
      "error"
    );
  }
}
 






function renderSuccess(txid) {
  app.innerHTML = `
    <div class="wallet-card success-card">

      <h1>✅ Транзакция отправлена</h1>

      <div class="tx-success">
        <div>TXID:</div>

        <code>
          ${escapeHtml(txid)}
        </code>
      </div>

      <button id="copyTxid">
        📋 Скопировать TXID
      </button>

      <button id="historyButton">
  📜 История
</button>

      <div class="status success">
        Транзакция передана в сеть Bitcoin.
      </div>

    </div>
  `;

  document
    .getElementById("copyTxid")
    ?.addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText(txid);

        setStatus(
          "TXID скопирован.",
          "success"
        );
      } catch {
        setStatus(
          "Не удалось скопировать TXID.",
          "error"
        );
      }
    });

    document
  .getElementById("historyButton")
  ?.addEventListener("click", loadHistory);
}

function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

async function loadHistory() {

  app.innerHTML = `
    <div class="wallet-card">
      <h1>📜 История</h1>
      <div class="status">
        Загрузка...
      </div>
    </div>
  `;

  try {

    const response =
      await fetch(
        "/api/wallet/1/history"
      );

    const data =
      await response.json();


    if (!data.ok) {
      throw new Error(data.error);
    }


    app.innerHTML = `
      <div class="wallet-card">

        <h1>📜 История</h1>

        ${
          data.history.map(tx => `
          
          <div class="transaction">

            <div class="row">
              <span>
                ${
                  tx.direction === "out"
                  ? "⬆️ Отправка"
                  : "⬇️ Получение"
                }
              </span>

              <strong>
                ${(tx.amountSats / 100000000).toFixed(8)}
                BTC
              </strong>
            </div>


            <div class="row">
              <span>Комиссия</span>

              <strong>
                ${
                  tx.feeSats
                  ? tx.feeSats + " sat"
                  : "—"
                }
              </strong>
            </div>


            <div class="row">
              <span>TXID</span>

              <code>
                ${tx.txid.slice(0,16)}...
              </code>
            </div>

          </div>

          `).join("")
        }

      </div>
    `;


  } catch(error) {

    renderError(error.message);

  }
}

window.addEventListener(
  "beforeunload",
  () => {
    secretSeed = clearSecret();
  }
);


function getTestMode() {
  const params = new URLSearchParams(window.location.search);
  return params.get("test") === "1";
}
function renderTestScreen() {
  app.innerHTML = `
    <div class="wallet-card">

      <h1>🧪 Тест подписи</h1>

      <div class="warning">
        Этот тест полностью локальный.
        Реальная seed-фраза не используется.
        Никакие Bitcoin-транзакции не отправляются.
      </div>

      <button id="runTestButton">
        🧪 Запустить тест
      </button>

      <div id="status" class="status"></div>

      <div id="testResult"></div>

    </div>
  `;

  document
    .getElementById("runTestButton")
    ?.addEventListener("click", runSigningTest);
}

function renderTestResult(result) {
  const resultElement = document.getElementById("testResult");

  if (!resultElement) {
    return;
  }

  resultElement.innerHTML = `
    <div class="transaction">

      <div class="row">
        <span>Статус</span>
        <strong>✅ Успешно</strong>
      </div>

      <div class="row">
        <span>Тестовый адрес</span>
        <strong>${escapeHtml(result.address)}</strong>
      </div>

      <div class="row">
        <span>Адрес назначения</span>
        <strong>${escapeHtml(result.destination)}</strong>
      </div>

      <div class="row">
        <span>TXID</span>
        <strong>${escapeHtml(result.txid)}</strong>
      </div>

      <div class="row">
        <span>Размер rawtx</span>
        <strong>${result.rawtxLength} символов</strong>
      </div>

    </div>

    <div class="status success">
      Подпись создана и проверена локально.
      В сеть ничего не отправлялось.
    </div>
  `;
}

function runSigningTest() {
  const button = document.getElementById("runTestButton");

  if (button) {
    button.disabled = true;
  }

  setStatus("Создаём тестовый Electrum wallet…");

  try {
    setStatus("Создаём фиктивный PSBT…");

    const result = runLocalSigningSelfTest();

    console.log("LOCAL SIGNING TEST:", result);

    renderTestResult(result);

    setStatus(
      "Тест локальной подписи успешно пройден.",
      "success"
    );
  } catch (error) {
    console.error("LOCAL SIGNING TEST FAILED:", error);

    setStatus(
      error.message || "Тест завершился ошибкой.",
      "error"
    );

    if (button) {
      button.disabled = false;
    }
  }
}

if (getTestMode()) {
  renderTestScreen();
} else {
  loadTransaction();
}

